import { conditionalClasses } from '@/utils';
import { type FC, useRef } from 'react';
import { useAiDisclosure } from './AiDisclosureContext';
import { AI_DISCLOSURE_SHIM_ID } from './AiDisclosureShim';
import type { AiLabelType } from '@/types/Recipes';

interface AiBadgeButtonProps {
  text?: string;
  title?: string;
  type?: AiLabelType;
  className?: string;
}

export const AiBadgeButton: FC<AiBadgeButtonProps> = ({ text, title, type, className }) => {
  const ref = useRef<HTMLButtonElement>(null);
  const { open, isOpen, activeTrigger, showBadge } = useAiDisclosure();
  const isExpanded = isOpen && activeTrigger === ref.current;

  if (!showBadge) {
    return;
  }

  return (
    <button
      ref={ref}
      type="button"
      aria-expanded={isExpanded}
      aria-controls={AI_DISCLOSURE_SHIM_ID}
      aria-label="Information about the AI-labeled image"
      onClick={(event) => open({ text, title, type }, event.currentTarget)}
      className={conditionalClasses(
        'absolute right-3 top-3 z-10 flex h-10 min-w-10 items-center justify-center rounded-full bg-neutral-900/50 px-3 text-base font-bold leading-none uppercase tracking-wide text-white backdrop-blur-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white',
        className,
      )}
    >
      AI
    </button>
  );
};
